import { IdValue } from '../../../../../../../types/props';

export const qrVariants: IdValue[] = [
  { id: 'logo', value: 'С логотипом' },
  { id: 'empty', value: 'Без логотипа' },
];

export type QrTextPlacementType = 'center' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
export const qrTextPlacements: IdValue[] = [
  {
    id: 'center',
    value: 'По центру',
  },
  {
    id: 'top-left',
    value: 'Сверху слева',
  },
  {
    id: 'top-right',
    value: 'Сверху справа',
  },
  {
    id: 'bottom-left',
    value: 'Снизу слева',
  },
  {
    id: 'bottom-right',
    value: 'Снизу справа',
  },
];

export const qrTemplates: IdValue[] = [{ id: 'empty', value: 'Без рамки' }];
